import userManual_LD from '@assets/pdf/user_manual_LD.pdf';
import userManual_Requester from '@assets/pdf/user_manual_Requester.pdf';
import userManual_Manager from '@assets/pdf/user_manual_Manager.pdf';
import LocalStorage from '@utils/localStorage';

export default function TrainingManual() {
  const user_details = LocalStorage.getItem('bbs_user');

  // user_details?.user?.Role?.role === 'REQUESTER' ||
  //   user_details?.user?.Role?.role === 'MANAGER' ||
  //   user_details?.user?.Role?.role === 'VIEWER';

  return (
    <div className="w-screen h-screen">
      <embed
        src={
          user_details?.user?.Role?.role === 'VIEWER'
            ? userManual_LD
            : user_details?.user?.Role?.role === 'REQUESTER'
              ? userManual_Requester
              : user_details?.user?.Role?.role === 'MANAGER'
                ? userManual_Manager
                : null
        }
        type="application/pdf"
        width="100%"
        height="100%"
      />
    </div>
  );
}
